import { ActivityIndicator, TouchableOpacity, View } from "react-native";
import { TranslateText } from "./translate-text";

const SubmitConfirmationModal = ({
  loading,
  setIsModalVisible,
  isModalVisible,
  isSubmitted,
}) => {
  return (
    <View
      style={{
        backgroundColor: "rgba(0,0,0,0.8)",
        height: "100%",
        width: "100%",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
      }}
    >
      {isSubmitted ? (
        <View
          style={{
            backgroundColor: "#FBFDF8",
            height: "20%",
            width: "90%",
            zIndex: 99999,
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: 8,
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TranslateText
              style={{ fontSize: 16, fontWeight: 500, textAlign: "center" }}
            >
              Submission successful
            </TranslateText>
          </View>
        </View>
      ) : (
        <View
          style={{
            backgroundColor: "#FBFDF8",
            height: "20%",
            width: "90%",
            zIndex: 99999,
            flexDirection: "column",
            justifyContent: "space-between",
            borderRadius: 8,
          }}
        >
          <View style={{ paddingTop: 24, paddingLeft: 24 }}>
            <TranslateText style={{ fontSize: 16, fontWeight: 500 }}>
              {isModalVisible.title}
            </TranslateText>
            <TranslateText style={{ fontSize: 14 }}>
              {isModalVisible.subtitle}
            </TranslateText>
          </View>
          {loading ? (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                paddingBottom: 12,
                paddingRight: 12,
              }}
            >
              <ActivityIndicator />
            </View>
          ) : (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "flex-end",
                paddingBottom: 12,
                paddingRight: 12,
              }}
            >
              <TouchableOpacity
                style={{
                  backgroundColor: "transparent",
                  padding: 12,
                  margin: 10,
                  borderRadius: 20,
                }}
                onPress={() => {
                  isModalVisible.cancelCallback
                    ? isModalVisible.cancelCallback()
                    : setIsModalVisible(null);
                }}
              >
                <TranslateText style={{ color: "#33CF71" }}>
                  {isModalVisible.cancel_button_name
                    ? isModalVisible.cancel_button_name
                    : "Cancel"}
                </TranslateText>
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  backgroundColor: "#33CF71",
                  padding: 12,
                  margin: 10,
                  borderRadius: 20,
                }}
                onPress={() => {
                  isModalVisible.callback();
                }}
              >
                <TranslateText style={{ color: "#FFF" }}>
                  {isModalVisible.button_name}
                </TranslateText>
              </TouchableOpacity>
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default SubmitConfirmationModal;
